import { render, staticRenderFns } from "./Abas.vue?vue&type=template&id=517347fa"
import script from "./Abas.vue?vue&type=script&lang=js"
export * from "./Abas.vue?vue&type=script&lang=js"
import style0 from "./Abas.vue?vue&type=style&index=0&id=517347fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports